import { DEEP_LINK_EXCLUSIONS } from '../../modules/routes/routes.utils';
import {
  ROUTING_SAVE_DEEPLINK,
  ROUTING_LOCATION_CHANGE,
  ROUTING_SET_IS_TOP_LEVEL_ROUTE,
  LANDING_SHOWN,
  SHOULD_DISPLAY_LANDING,
  SET_ROUTE_SKELETON,
} from './routing.actions';

const initialState = {
  deeplink: '',
  isOpenedViaDeeplink: false,
  currentRoute: '',
  currentPath: '',
  skeleton: null,
  isTopLevelRoute: false,
  shouldDisplayLanding: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ROUTING_SAVE_DEEPLINK: {
      const deeplink = action.deeplink && !DEEP_LINK_EXCLUSIONS.includes(action.deeplink) ? action.deeplink : '';

      return {
        ...state,
        deeplink,
        isOpenedViaDeeplink: state.isOpenedViaDeeplink || Boolean(deeplink),
      };
    }
    case ROUTING_LOCATION_CHANGE:
      return {
        ...state,
        currentRoute: action.location,
        currentPath: action.path,
      };
    case ROUTING_SET_IS_TOP_LEVEL_ROUTE:
      return {
        ...state,
        isTopLevelRoute: action.isTopLevelRoute,
      };
    case LANDING_SHOWN:
      return {
        ...state,
        shouldDisplayLanding: false,
      };
    case SHOULD_DISPLAY_LANDING:
      return {
        ...state,
        shouldDisplayLanding: true,
      };
    case SET_ROUTE_SKELETON:
      return {
        ...state,
        skeleton: action.skeleton || null,
      };
    default:
      return state;
  }
};
